import { useContext } from 'react';
import { PrimaryButton } from '@/common/Button';
import { getHomeHref as getHref } from '@/common/SearchBar/utils';
import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '@/home/utils/formatEvent';
import TagIds from '~/constants/common/tagIds';
import { useConfiguration } from '~/context/common/StaticContext';
import UserContext from '~/context/common/UserContext';
import { nativeSrpPayload } from '~/native/home/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import {
  SectionWrapper,
  InnerWrapper,
  ContentWrapper,
  ImageWrapper,
  VehicleImage,
  StyledWave,
  ContentText,
  StyledNewPriceIcon
} from './styles';

const NewPriceBanner = () => {
  const {
    location: {
      data: { state = '' }
    }
  } = useContext(UserContext);

  const { priceDropRestrictedStates } = useConfiguration();
  const isInRestrictedState =
    !priceDropRestrictedStates || priceDropRestrictedStates.includes(state);
  const newPriceSearchLink = getHref(
    generateSearchLinkFilter({
      filters: { tagIds: [String(TagIds.PriceDrop)] }
    })
  );

  const viewEvent = formatEvent('Viewed - Home feed section', {
    description: 'Price drop'
  });

  return (
    <TrackWrapper event={viewEvent}>
      <SectionWrapper data-qa="New Price Banner">
        <StyledWave />
        <InnerWrapper>
          <ImageWrapper>
            <VehicleImage
              alt="New Price Vehicle"
              src={`${process.env.CVNA_APP_CDN_URL}/home-assets/redesign/new-price-drop.png?bg-color=transparent`}
            />
            <StyledNewPriceIcon isInRestrictedState={isInRestrictedState} />
          </ImageWrapper>
          <ContentWrapper>
            <ContentText>
              {isInRestrictedState
                ? 'We’ve updated prices on select vehicles, don’t miss out!'
                : 'We’ve lowered prices to give you more savings. Don’t miss out!'}
            </ContentText>
            <a
              href={newPriceSearchLink}
              data-analytics-id="Home feed card"
              data-analytics-attributes={JSON.stringify({
                description: 'Price drop cta'
              })}
              data-qa="show-all-new-prices"
              data-native-payload={nativeSrpPayload}
            >
              <PrimaryButton
                className="w-[250px] w-full border border-blue-2"
                size="small"
                mode="dark"
              >
                {isInRestrictedState
                  ? 'Shop All New Prices'
                  : 'Shop All Price Drops'}
              </PrimaryButton>
            </a>
          </ContentWrapper>
        </InnerWrapper>
      </SectionWrapper>
    </TrackWrapper>
  );
};

export default NewPriceBanner;
